import React, { useEffect } from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import themes from '../utils/themes';
import App from '../App';
import darkThemes from '../utils/darkThemes';
import { useSelector } from 'react-redux';
import { getAppMode } from '../features/auth/authSlice';
import { SkeletonTheme } from 'react-loading-skeleton';
import { useLocation } from 'react-router-dom';
import { isPublicPage } from '../utils/helper';
import PostHogUserSync from '../analytics/PostHogUserSync';

const ThemeCssVars = createGlobalStyle`
  html,
  html[data-bs-theme='light'],
  html[data-bs-theme='dark'] {
    --bs-workspace-bg: ${({ theme }) => theme.workspaceBg};
    --bs-body-bg: ${({ theme }) => theme.workspaceBg};
    --bs-body-bg-rgb: ${({ theme }) => theme.workspaceRgb};
    --bs-header-bg: ${({ theme }) => theme.headerBg};
    --bs-modal-header-bg: ${({ theme }) => theme.modalHeaderBg};
    --bs-modal-header-color: ${({ theme }) => theme.onHeader};
    --bs-surface: ${({ theme }) => theme.surface};
    --bs-surface-subtle: ${({ theme }) => theme.surfaceSubtle};
    --bs-card-bg: ${({ theme }) => theme.cardBg};
    --bs-field-label-bg: ${({ theme }) => theme.fieldLabelBg};
    --bs-on-header: ${({ theme }) => theme.onHeader};
    --bs-actionIcons: ${({ theme }) => theme.actionsIconColor};
    --bs-table-text: ${({ theme }) => theme.tableText};
    --bs-pagination-active-bg: ${({ theme }) => theme.paginationActiveBg};
    --bs-pagination-active-color: ${({ theme }) => theme.paginationActiveColor};
    --bs-pagination-muted: ${({ theme }) => theme.paginationMuted};
    --bs-pagination-btn-bg: ${({ theme }) => theme.paginationBtnBg};
    --bs-pagination-btn-border: ${({ theme }) => theme.paginationBtnBorder};
    --bs-pagination-btn-color: ${({ theme }) => theme.paginationBtnColor};
    --bs-drop-zone-bg: ${({ theme }) => theme.dropZoneBg};
    --bs-portlet-bg: ${({ theme }) => theme.portletBg};
    --bs-modal-bg: ${({ theme }) => theme.modalBg};
    --bs-modal-panel-bg: ${({ theme }) => theme.modalPanelBg};
    --radius-card: ${({ theme }) => theme.radiusCard};
    --radius-modal: ${({ theme }) => theme.radiusModal};
  }
`;

const ThemeContext = () => {
  const location = useLocation(); // H
  const darkMode = useSelector(getAppMode);
  useEffect(() => {
    const currentPath = location.pathname;
    document.documentElement.setAttribute(
      'data-theme',
      isPublicPage(currentPath) ? 'light' :darkMode ? 'dark' : 'light',
    );
    document.documentElement.setAttribute(
      'data-bs-theme',
      isPublicPage(currentPath) ? 'light' : darkMode ? 'dark' : 'light',
    );
  }, [darkMode, location.pathname]);

  return (
    <div >
      <SkeletonTheme
        baseColor={
          darkMode &&  !isPublicPage(location?.pathname) ? darkThemes?.skeltonBaseColor : themes?.skeltonBaseColor
        }
        highlightColor={
          darkMode &&  !isPublicPage(location?.pathname) 
            ? darkThemes?.skeltonHighlightColor
            : themes?.skeltonHighlightColor
        }
      >
        <ThemeProvider theme={darkMode &&  !isPublicPage(location?.pathname)  ? darkThemes : themes || {}}>
          <ThemeCssVars />
          <PostHogUserSync />
          <App />
        </ThemeProvider>
      </SkeletonTheme>
    </div>
  );
};

export default ThemeContext;
